/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimInsuredObjectDetailsResponseDto } from '../models/clm-claim-insured-object-details-response-dto';


/**
 * the ClaQueryInsuredObjectDetails API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryInsuredObjectDetailsService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getInsuredObjectsDetails
   */
  static readonly GetInsuredObjectsDetailsPath = '/claim/{claimId}/insured-object/{code}';

  /**
   * Get insured object's details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInsuredObjectsDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInsuredObjectsDetails$Response(params: {
    claimId: string;
    code: string;
    language?: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimInsuredObjectDetailsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryInsuredObjectDetailsService.GetInsuredObjectsDetailsPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.path('code', params.code, {});
      rb.query('language', params.language, {});
      rb.header('X-Authorization', params['X-Authorization'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimInsuredObjectDetailsResponseDto>;
      })
    );
  }

  /**
   * Get insured object's details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInsuredObjectsDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInsuredObjectsDetails(params: {
    claimId: string;
    code: string;
    language?: string;
    'X-Authorization'?: string;
  },
  context?: HttpContext

): Observable<ClmClaimInsuredObjectDetailsResponseDto> {

    return this.getInsuredObjectsDetails$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimInsuredObjectDetailsResponseDto>) => r.body as ClmClaimInsuredObjectDetailsResponseDto)
    );
  }

}
